import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/emergency';

const sortTableFields = ["elevator.countryName"];
const sortDatabaseFields = ["elevator.country.name"];

const serviceName = "Emergency-Service: ";

export default class EmergencyCenterService {

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + "/page", {params : params}, serviceName, successF, errorF);
  }

  static async readElevatorPaginatedFromAPI(elevatorId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortTableFields, sortDatabaseFields)
    await WrapperService.get(API_URL + '/elevator/' + elevatorId + '/page',
      {params : params}, serviceName, successF, errorF);
  }

  static async readFromAPI(emergencyId, successF, errorF) {
    await WrapperService.get(API_URL + '/get/' + emergencyId, null, serviceName, successF, errorF);
  }

  static async readImageDataFromAPI(emergencyId, successF, errorF) {
    await WrapperService.get(API_URL + '/get/' + emergencyId + '/camera/info', null, serviceName, successF, errorF);
  }

  static async getComments(emergencyId, tokenId, successF, errorF) {
    let url = `/comments/${emergencyId}/${tokenId}`;
    await WrapperService.get(API_URL + url, null, serviceName, successF, errorF);
  }

  static async getAnswers(emergencyId, tokenId, successF, errorF) {
    let url = `/answers/${emergencyId}/${tokenId}`;
    await WrapperService.get(API_URL + url, null, serviceName, successF, errorF);
  }

  static async getEmergency(emergencyId, tokenId, successF, errorF) {
    let url = `/info/${emergencyId}/${tokenId}`;
    await WrapperService.get(API_URL + url, null, serviceName, successF, errorF);
  }

  static async getGallery(emergencyId, tokenId, successF, errorF) {
    let url = `/gallery/${emergencyId}/${tokenId}`;
    await WrapperService.get(API_URL + url, null, serviceName, successF, errorF);
  }

  static async addComment(emergencyId, tokenId, comment, successF, errorF) {
    let url = `/comment/${emergencyId}/${tokenId}`;
    await WrapperService.post(API_URL + url, {comment: comment}, serviceName, successF, errorF);
  }

  static async closeEmergency(emergencyId, tokenId, successF, errorF) {
    let url = `/close/${emergencyId}/${tokenId}`;
    await WrapperService.post(API_URL + url, null, serviceName, successF, errorF);
  }

  static async imageRequest(emergencyId, tokenId, elevatorId, successF, errorF) {
    let url = `/elevator/${elevatorId}/image/request/${emergencyId}/${tokenId}`;
    await WrapperService.post(API_URL + url, null, serviceName, successF, errorF);
  }
}
